/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { PensionCompaniesContext } from './PensionCompaniesContext';

export default () => React.useContext(PensionCompaniesContext);
